import { render, staticRenderFns } from "./SessionCalendar.vue?vue&type=template&id=83c4e356"
import script from "./SessionCalendar.vue?vue&type=script&lang=js"
export * from "./SessionCalendar.vue?vue&type=script&lang=js"
import style0 from "./SessionCalendar.vue?vue&type=style&index=0&id=83c4e356&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports